import { convertToBgn } from './convertToBgn';
import { convertToEur } from './convertToEur';
import { Currency } from './enums/currency-type.enum';
import { roundPrice } from './roundPrice';

// displays price in both BGN and EUR currencies
export function displayPrice(
  price: number,
  bgnLabel: string,
  eurLabel: string,
  currency?: Currency
): string {
  const resolvedCurrency = currency ?? Currency.EUR;
  const isBGN = resolvedCurrency === Currency.BGN;

  // Show ONLY EUR on January 1, 2027
  const switchDate = new Date(2027, 0, 1);
  const eurOnly = new Date() >= switchDate;

  let bgnValue: string;
  let eurValue: string;

  if (isBGN) {
    bgnValue = roundPrice(price);
    eurValue = convertToEur(price);
  } else {
    eurValue = roundPrice(price);
    bgnValue = convertToBgn(price);
  }

  const bgnText = `${bgnValue} ${bgnLabel}`;
  const eurText = `${eurValue} ${eurLabel}`;

  return eurOnly ? eurText : `${eurText} / ${bgnText}`;
}
